import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateOnly',
  standalone: true
})
export class StringToDateOnlyPipe implements PipeTransform {

  transform(value: string) : Date | string{

    if (value == null || !value.includes('T') || !value.includes('-')) {return value; }

    const [date, _] = value.split('T');
    const [year, month, day] = date.split('-').map(Number);

    return new Date(year, month - 1 , day);
  }
}
